/* eslint-disable */
//
import React from "react"
import PropTypes from "prop-types"
import moment from "moment"

import {
    enumSingleGenericFilter,
    datePickerGenericFilter,
    textGenericFilter,
    enumOrderSort,
    enumValueSort,
} from "shared/search/containers/Filter/Filters"
import {
    searchifySelectGenericFilter,
    toggleGenericFilter,
    enumGenericFilter,
} from "shared/search/containers/Filter/FilterCreators"

import {
    BulkEmailFilterableListView,
    OfficialInOutboxFilterableListView,
    StafferFilterableListView,
    SupporterFilterableListView,
    OfficialsAndStaffEUFilterableListView,
    PressContactFilterableListView,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import {
    BulkEmailSelect,
    StafferSelect,
    ContactSelect,
    OfficialsAndStaffSelect,
    PressContactSelect,
    OfficialWithoutCampaignFinanceSelect,
} from "app/static/frontend/selects/containers/PieSelect"

import { usRegions, allRegionsExceptUS, federalAndStates } from "shared/imports/regionConstants"

const defaultEnumPropTypes = {
    displayLabel: PropTypes.string,
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    uniqueFilterId: PropTypes.string,

    enumItems: PropTypes.array,
    helpText: PropTypes.string,
    sortBy: PropTypes.func,
}

const dateDefaultPropTypes = {
    displayLabel: PropTypes.string,
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    uniqueFilterId: PropTypes.string,
    helpText: PropTypes.string,
    noFuture: PropTypes.bool,
}

export const SendEmailBulkEmailFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={BulkEmailFilterableListView} {...props} />
}
SendEmailBulkEmailFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
SendEmailBulkEmailFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "sendEmailBulkEmailFilter",
    filterKey: "about_email",
    dataTypeLabel: "Outbox Emails",
    selectComponent: BulkEmailSelect,
}

export const SendEmailToTypeFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
SendEmailToTypeFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    enumItems: PropTypes.array,
    enumGroups: PropTypes.array,
    displayLabel: PropTypes.string,
    sortBy: PropTypes.func,
}
SendEmailToTypeFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "sendEmailToTypeFilter",
    filterKey: "sent_to_enum",
    enumItems: DjangIO.app.userdata.outbox.types.SentToType.items(),
    sortBy: enumValueSort,
}

export const SendEmailOfficialFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={OfficialInOutboxFilterableListView} {...props} />
}
SendEmailOfficialFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
    regions: PropTypes.array,
    permissions: PropTypes.array,
}
SendEmailOfficialFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "sendEmailOfficialFilter",
    filterKey: "about_official",
    dataTypeLabel: "Officials",
    selectComponent: OfficialWithoutCampaignFinanceSelect,
    regions: usRegions,
    permissions: [
        DjangIO.app.models.PermissionType.legislators,
        DjangIO.app.models.PermissionType.executives,
        DjangIO.app.models.PermissionType.staffers,
    ],
}

export const SendEmailStafferFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={StafferFilterableListView} {...props} />
}
SendEmailStafferFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
    regions: PropTypes.array,
    permissions: PropTypes.array,
}
SendEmailStafferFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "sendEmailStafferFilter",
    filterKey: "about_official",
    dataTypeLabel: DjangIO.app.models.QuorumDataType.staffer.plural,
    selectComponent: StafferSelect,
    regions: federalAndStates,
    permissions: [
        DjangIO.app.models.PermissionType.legislators,
        DjangIO.app.models.PermissionType.executives,
        DjangIO.app.models.PermissionType.staffers,
    ],
}

export const SendEmailOfficialsAndStaffersFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={OfficialsAndStaffEUFilterableListView} {...props} />
}
SendEmailOfficialsAndStaffersFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
    regions: PropTypes.array,
}
SendEmailOfficialsAndStaffersFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "sendEmailOfficialsAndStaffersFilter",
    filterKey: "about_official",
    dataTypeLabel: "Officials",
    selectComponent: OfficialsAndStaffSelect,
    regions: allRegionsExceptUS,
}

export const SendEmailPressContactFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={PressContactFilterableListView} {...props} />
}
SendEmailPressContactFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
    regions: PropTypes.array,
    permissions: PropTypes.array,
}
SendEmailPressContactFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "sendEmailPressContactFilter",
    filterKey: "about_press",
    dataTypeLabel: DjangIO.app.models.QuorumDataType.press_contact.plural,
    selectComponent: PressContactSelect,
    permissions: [DjangIO.app.models.PermissionType.media_relations],
}

export const SendEmailContactFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={SupporterFilterableListView} {...props} />
}
SendEmailContactFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
SendEmailContactFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "sendEmailContactFilter",
    filterKey: "about_supporter",
    dataTypeLabel: "Contacts",
    selectComponent: ContactSelect,
}

export const SendEmailReceivedFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
SendEmailReceivedFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
}
SendEmailReceivedFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "sendEmailReceivedFilter",
    filterKey: "received",
    displayLabel: "Received",
    trueText: "Yes",
    falseText: "No",
}

export const SendEmailOpenedFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
SendEmailOpenedFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
    helpText: PropTypes.string,
}
SendEmailOpenedFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "sendEmailOpenedFilter",
    filterKey: "opened",
    displayLabel: "Opened",
    trueText: "Yes",
    falseText: "No",
    helpText: "Combined count of Top Pixel Open (initial_open) OR Bottom Pixel Open (open) OR Click Event (click).",
}

export const SendEmailClickedFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
SendEmailClickedFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
}
SendEmailClickedFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "sendEmailClickedFilter",
    filterKey: "clicked",
    displayLabel: "Clicked",
    trueText: "Yes",
    falseText: "No",
}

export const SendEmailRepliedFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
SendEmailRepliedFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
}
SendEmailRepliedFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "sendEmailRepliedFilter",
    filterKey: "did_reply",
    displayLabel: "Replied",
    trueText: "Yes",
    falseText: "No",
}

export const SendEmailOfficialsFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
SendEmailOfficialsFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
    permissions: PropTypes.array,
}
SendEmailOfficialsFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "sendEmailOfficialsFilter",
    filterKey: "sent_to_officials",
    displayLabel: "Sent to Official",
    trueText: "Yes",
    falseText: "No",
    permissions: [
        DjangIO.app.models.PermissionType.legislators,
        DjangIO.app.models.PermissionType.executives,
        DjangIO.app.models.PermissionType.staffers,
    ],
}

export const SendEmailStaffersFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
SendEmailStaffersFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
    regions: PropTypes.array,
    permissions: PropTypes.array,
}
SendEmailStaffersFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "sendEmailStaffersFilter",
    filterKey: "sent_to_staffers",
    displayLabel: "Sent to Staffer",
    regions: federalAndStates,
    trueText: "Yes",
    falseText: "No",
    permissions: [
        DjangIO.app.models.PermissionType.legislators,
        DjangIO.app.models.PermissionType.executives,
        DjangIO.app.models.PermissionType.staffers,
    ],
}

export const SendEmailPressContactsFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
SendEmailPressContactsFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
    permissions: PropTypes.array,
}
SendEmailPressContactsFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "sendEmailPressContactsFilter",
    filterKey: "sent_to_press",
    displayLabel: "Sent to Press",
    trueText: "Yes",
    falseText: "No",
    permissions: [DjangIO.app.models.PermissionType.media_relations],
}

export const SendEmailContactsFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
SendEmailContactsFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
}
SendEmailContactsFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "sendEmailContactsFilter",
    filterKey: "sent_to_supporters",
    displayLabel: "Sent to Contact",
    trueText: "Yes",
    falseText: "No",
}

export const SendEmailTitleFilter = (props) => {
    const FilterComponent = props.filterComponent || textGenericFilter
    return <FilterComponent {...props} />
}
SendEmailTitleFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    placeholderText: PropTypes.string,
    displayLabel: PropTypes.string,
}
SendEmailTitleFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "sendEmailTitleFilter",
    filterKey: "title_search",
    placeholderText: "Search by title",
    displayLabel: "Search by Job Title",
}

export const SendEmailContactOrganizationFilter = (props) => {
    const FilterComponent = props.filterComponent || textGenericFilter
    return <FilterComponent {...props} />
}
SendEmailContactOrganizationFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    placeholderText: PropTypes.string,
    displayLabel: PropTypes.string,
}
SendEmailContactOrganizationFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "sendEmailContactOrganizationFilter",
    filterKey: "contact_organization_search",
    placeholderText: "Search by organization name",
    displayLabel: "Search by Organization Name",
}

export const SendEmailEmailAddressFilter = (props) => {
    const FilterComponent = props.filterComponent || textGenericFilter
    return <FilterComponent {...props} />
}
SendEmailEmailAddressFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    placeholderText: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}
SendEmailEmailAddressFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "sendEmailEmailAddressFilter",
    filterKey: "email_address_search",
    placeholderText: "Search by email address",
    displayLabel: "Search by Email Address",
    helpText: "You can search for text contained in multiple email addresses by separating your inputs with a comma",
}

export const SendEmailRecipientNameFilter = (props) => {
    const FilterComponent = props.filterComponent || textGenericFilter
    return <FilterComponent {...props} />
}
SendEmailRecipientNameFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    placeholderText: PropTypes.string,
    displayLabel: PropTypes.string,
}
SendEmailRecipientNameFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "sendEmailRecipientNameFilter",
    filterKey: "recipient_name_search",
    placeholderText: "Search by name",
    displayLabel: "Search by Name",
}

export const SendEmailCreatedDateNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || enumSingleGenericFilter
    return <FilterComponent {...props} />
}
SendEmailCreatedDateNoFutureFilter.propTypes = defaultEnumPropTypes
SendEmailCreatedDateNoFutureFilter.defaultProps = {
    filterComponent: enumSingleGenericFilter,
    uniqueFilterId: "sendEmailCreatedDateNoFutureFilter",
    filterKey: "date_range",
    enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items().filter(
        (item) =>
            ![
                DjangIO.app.events.models.DateRangeType.future.value,
                DjangIO.app.events.models.DateRangeType.next_month.value,
                DjangIO.app.events.models.DateRangeType.next_week.value,
            ].includes(item.value),
    ),
    sortBy: enumOrderSort,
    displayLabel: "Date Created",
    helpText:
        "Filter for results that were added to quorum after a particular date " + "or within a specific date range.",
}

export const SendEmailCreatedDatePickerStartNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} minDate={moment().subtract(1, "years").toISOString()} />
}
SendEmailCreatedDatePickerStartNoFutureFilter.propTypes = dateDefaultPropTypes
SendEmailCreatedDatePickerStartNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "sendEmailCreatedDatePickerStartNoFutureFilter",
    filterKey: "created__gt",
    displayLabel: "Start Date",
    noFuture: true,
    helpText: "Outbox emails created after date selected. Excludes date selected.",
}

export const SendEmailCreatedDatePickerEndNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} minDate={moment().subtract(1, "years").toISOString()} />
}
SendEmailCreatedDatePickerEndNoFutureFilter.propTypes = dateDefaultPropTypes
SendEmailCreatedDatePickerEndNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "sendEmailCreatedDatePickerEndNoFutureFilter",
    filterKey: "created__lt",
    displayLabel: "End Date",
    noFuture: true,
    helpText: "Outbox emails created before date selected. Excludes date selected.",
}

// this is an invisible filter we have to include so that when we are seguing
// from an outbox email to see who clicked the links, the `contains_clicked_link`
// querymethod is being applied properly. If this is not here, the invalid
// querymethod will be deleted from the url string
export const ClickedLinkFilter = (props) => {
    const FilterComponent = props.filterComponent || textGenericFilter
    return <FilterComponent {...props} />
}
ClickedLinkFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    invisible: PropTypes.bool,
}
ClickedLinkFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "clickedLinkFilter",
    filterKey: "contains_clicked_link",
    invisible: true,
}
